import Helpers from "@/helpers/Helpers";

export default [
  //   BUILDINGS
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/edit",
    name: "BuildingEdit",
    component: Helpers.lazyLoad("BuildingAddEditView", "views/content/buildings"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId(add)",
    name: "BuildingAdd",
    component: Helpers.lazyLoad("BuildingAddEditView", "views/content/buildings"),
    meta: { requiresAuth: true }
  }
];
